import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { ORDER_URL } from '../constants/translations';
import { useLanguage } from '../context/LanguageContext';
type OrderButtonProps = {
  /** "solid" = filled caramel primary; "outline" = bordered for darker spotlight sections. */
  variant?: 'solid' | 'outline';
  /** Show the small pickup sub-label beneath the button. */
  withSub?: boolean;
  className?: string;
};
export function OrderButton({
  variant = 'solid',
  withSub = false,
  className = ''
}: OrderButtonProps) {
  const {
    t
  } = useLanguage();
  const o = t.order;
  const base = 'group inline-flex items-center gap-3 px-9 py-4 text-[11px] tracking-[0.35em] uppercase font-medium transition-all duration-500';
  const styles = variant === 'solid' ? 'bg-caramel text-chocolate hover:bg-cream' : 'border border-cream/30 text-cream hover:border-caramel hover:text-caramel';
  return <div className={`flex flex-col items-center gap-4 ${className}`} data-id="element-265" data-mp="fjaqo3ktekwc">
      <a href={ORDER_URL} target="_blank" rel="noreferrer" className={`${base} ${styles}`} data-id="element-266" data-mp="18w9qudeno8bz">
        <span data-id="element-267" data-mp="1du1sw090latw">{o.label}</span>
        <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.75} data-id="element-268" data-mp="1dubgxiai17wy" />
      </a>
      {withSub && <span className="text-[10px] tracking-[0.3em] uppercase text-cream/45" data-id="element-269" data-mp="13yrqvcim93g4">
          {o.sub}
        </span>}
    </div>;
}